'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M658.744 722.744l-82.744 82.746v-586.98l82.744 82.746c12.498 12.496 28.878 18.744 45.256 18.744s32.758-6.248 45.256-18.746c24.992-24.994 24.992-65.516 0-90.51l-192-192c-24.996-24.994-65.516-24.994-90.51 0l-192 192c-24.994 24.994-24.994 65.516 0 90.51s65.516 24.994 90.51 0l82.744-82.744v586.98l-82.746-82.746c-24.994-24.992-65.516-24.992-90.51 0-24.994 24.994-24.994 65.518 0 90.512l192 192c12.498 12.496 28.878 18.744 45.256 18.744s32.758-6.248 45.256-18.744l192-192c24.992-24.994 24.992-65.518 0-90.512-24.996-24.992-65.516-24.992-90.512 0z' })
    ));
};